<template>
<div class="chapter">
<div class="inner_page">
<h2><a id="page_29"></a><a id="pg29lev1"></a><img alt="Razor clams with tzatziki and pomegranate" src="images/f0029-01.jpg"/></h2>
<p class="recipe_hdnote">Whenever there are starters being served in Turkey, a small dish of tzatziki is likely to appear. It’s a simple blend of cucumber, garlic, and creamy yogurt, but each family and restaurant will have their own secret method and ratio, making it their signature.</p>
<p class="recipe_hdnote">In my view, the perfect tzatziki is made using a crunchy Lebanese or ridge cucumber with the seeds scooped out; salting it in a colander also draws out the moisture. Pomegranate seeds are the perfect way to elevate any dish, savory or sweet, and they add an exceedingly satisfying crunch.</p>
<div class="wrap">
<p class="image"><a id="page_28"></a><img alt="image" class="vertical" src="images/f0028-01.jpg"/></p>
</div>
<p class="yield">Serves 4 as a canap<span class="display_type">é</span> or starter</p>
<div class="wrap_small">
<p class="image"><img alt="image" src="images/common.jpg"/></p>
</div>
<p class="yield">Preparation time: 10 minutes</p>
<div class="wrap_small">
<p class="image"><img alt="image" src="images/common1.jpg"/></p>
</div>
<p class="yield">Cooking time: 30 seconds</p>
<div class="wrap_small">
<p class="image"><img alt="image" src="images/common2.jpg"/></p>
</div>
<p class="ingred_sublist">8 razor clams</p>
<p class="ingred_sublist"><sup>1</sup>/<sub>2</sub> lemon</p>
<p class="ingred_sublist">5 tbsp Greek yogurt</p>
<p class="ingred_sublist">1 small clove of garlic, peeled and minced</p>
<p class="ingred_sublist">pinch of sea salt</p>
<p class="ingred_sublist"><sup>1</sup>/<sub>2</sub> Lebanese cucumber or ridge cucumber, peeled</p>
<p class="ingred_sublist"><sup>1</sup>/<sub>4</sub> cup pomegranate seeds</p>
<p class="method_txt">Bring a large saucepan of water to a boil. Set up a large bowl of iced water nearby. Drop 4 razor clams into the boiling water, then fish them out almost immediately with a pair of tongs and drop them straight into the iced water. They should open but not cook. Repeat with the remaining clams.</p>
<p class="method_txt">Pull the clams out of their shells and use a pair of scissors to cut the black sac out of the clam, remove the “beak,” then chop the clams into thumbnail-size pieces. Put the clams into a bowl and squeeze a little lemon juice over the top. Wash and dry 8 half-shells and set aside.</p>
<p class="method_txt">Mix together the yogurt, garlic, salt, and a squeeze of lemon. Place in a disposable piping bag or ziplock bag and snip off the end.</p>
<p class="method_txt">Cut the cucumber in half lengthwise and scoop out the seeds. Cut into fine julienne strips on a mandoline or by hand.</p>
<p class="method_txt">Put 3 or 4 dollops of the garlic yogurt along a half-shell. Put the clam pieces in between the yogurt. Garnish with cucumber and scatter some of the pomegranate seeds over the top. Repeat with the remaining half-shells and serve.</p>
<p class="sidebar2_hd">Tip</p>
<p class="sidebar1_txt"><em>A good way to tell if your clams are fresh is to tickle the foot, which should retract right away; if there is no sign of life, don’t buy them</em>.</p>
<div class="wrap_small">
<p class="image"><img alt="image" src="images/f0029-02.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 14-chapter08.vue?31b53080